<template>
    <section id="wrapper" class="auth-saas auth-saas--pro">
        <div class="auth-saas__layout auth-saas__layout--split">
            <aside
                class="auth-saas__brand-panel nk-split-stretch toggle-break-lg toggle-slide toggle-slide-right d-none d-lg-flex"
                data-toggle-body="true"
                data-content="athPromo"
                data-toggle-screen="lg"
                data-toggle-overlay="true"
            >
                <div class="auth-saas__brand-atmosphere" aria-hidden="true">
                    <span class="auth-saas__brand-grid"></span>
                    <span class="auth-saas__brand-glow auth-saas__brand-glow--a"></span>
                    <span class="auth-saas__brand-glow auth-saas__brand-glow--b"></span>
                    <span class="auth-saas__brand-beam"></span>
                </div>
                <div class="auth-saas__brand-content">
                    <div class="auth-saas__brand-lockup">
                        <span class="auth-saas__brand-mark" aria-hidden="true">S</span>
                        <div>
                            <p class="auth-saas__brand-wordmark">Sipinor</p>
                            <p class="auth-saas__brand-product">Admin Console</p>
                        </div>
                    </div>
                    <h2 class="auth-saas__brand-headline">Operate your education platform with precision.</h2>
                    <p class="auth-saas__brand-copy">
                        Sign in to manage subscriptions, tenant instances, and administrative controls from a single secure workspace.
                    </p>
                    <ul class="auth-saas__capability-list">
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="school"></admin-icon>
                            </span>
                            <div>
                                <strong>Centralized operations</strong>
                                <span>Tenants, billing, and configuration in one place</span>
                            </div>
                        </li>
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="shield"></admin-icon>
                            </span>
                            <div>
                                <strong>Role-based security</strong>
                                <span>Least-privilege access for every administrator</span>
                            </div>
                        </li>
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="chart"></admin-icon>
                            </span>
                            <div>
                                <strong>Operational clarity</strong>
                                <span>Status, alerts, and activity you can act on</span>
                            </div>
                        </li>
                    </ul>
                    <p class="auth-saas__brand-meta">Encrypted sessions · Optional two-factor verification</p>
                </div>
            </aside>

            <div class="auth-saas__form-column auth-saas__form-column--split">
                <div class="absolute-top-right d-lg-none p-3">
                    <a href="#" class="auth-saas__icon-btn toggle" data-target="athPromo" aria-label="About Sipinor Admin">
                        <admin-icon name="info"></admin-icon>
                    </a>
                </div>
                <div class="auth-saas__form-main">
                    <div class="auth-saas__form-inner auth-saas__form-inner--enter">
                        <div class="auth-saas__mobile-brand d-lg-none">
                            <span class="auth-saas__brand-mark auth-saas__brand-mark--sm" aria-hidden="true">S</span>
                            <span>Sipinor Admin</span>
                        </div>
                        <div class="auth-saas__card auth-saas__card--login">
                            <h1 class="auth-saas__title">{{ trans('auth.login') }}</h1>
                            <p class="auth-saas__subtitle">Enter your credentials to continue to the admin console.</p>
                            <form
                                class="form-validate is-alter"
                                id="loginform"
                                @submit.prevent="submit"
                                @keydown="loginForm.errors.clear($event.target.name)"
                            >
                                <div class="form-group">
                                    <label for="email-address" class="auth-saas__label">Email</label>
                                    <div class="auth-saas__input-wrap">
                                        <admin-icon name="mail" aria-hidden="true"></admin-icon>
                                        <input
                                            id="email-address"
                                            type="text"
                                            name="email"
                                            class="auth-saas__input"
                                            autocomplete="username"
                                            :placeholder="trans('auth.email')"
                                            v-model="loginForm.email"
                                        >
                                    </div>
                                    <show-error :form-name="loginForm" class="text-danger" prop-name="email"></show-error>
                                </div>
                                <div class="form-group">
                                    <div class="auth-saas__row">
                                        <label for="login-password" class="auth-saas__label mb-0">Password</label>
                                        <router-link
                                            v-if="getConfig('reset_password')"
                                            to="/password"
                                            class="auth-saas__link"
                                        >{{ trans('auth.reset_here!') }}</router-link>
                                    </div>
                                    <div class="auth-saas__input-wrap">
                                        <admin-icon name="lock" aria-hidden="true"></admin-icon>
                                        <input
                                            id="login-password"
                                            type="password"
                                            name="password"
                                            class="auth-saas__input"
                                            autocomplete="current-password"
                                            :placeholder="trans('auth.password')"
                                            v-model="loginForm.password"
                                        >
                                    </div>
                                    <show-error :form-name="loginForm" class="text-danger" prop-name="password"></show-error>
                                </div>
                                <div class="form-group mb-0">
                                    <button type="submit" class="auth-saas__btn" :disabled="loginForm.busy">
                                        <span v-if="loginForm.busy" class="auth-saas__btn-spinner" aria-hidden="true"></span>
                                        <admin-icon name="arrow-right" v-else aria-hidden="true"></admin-icon>
                                        <span>{{ trans('auth.login') }}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="auth-saas__footer">
                    <p>© Sipinor Educational Solutions</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                loginForm: new Form({
                    email: '',
                    password: ''
                })
            }
        },
        methods: {
            submit(){
                this.loginForm.post('/api/auth/login')
                    .then(response =>  {
                        localStorage.setItem('auth_token',response.token);
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
                        this.$store.dispatch('setAuthStatus');
                        this.$store.dispatch('setLastActivity');
                        toastr.success(response.message);

                        if(helper.getConfig('two_factor_security') && response.two_factor_code){
                            this.$store.dispatch('setTwoFactorCode',response.two_factor_code);
                            this.$router.push('/auth/security');
                        }
                        else {
                            this.$store.dispatch('resetTwoFactorCode');
                            this.$router.push('/home');
                        }
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>
